import UploadFile from "../CaseUploadFile/UploadFile";
import React from "react";
import CreatePaidTaskModal from "../CaseModals/CreatePaidTaskModal";
import PauseModal from "../CaseModals/PauseModal";
import StatusModal from "../CaseModals/StatusModal";
import DeleteCaseOrAccountModal from "../CaseModals/DeleteCaseOrAccountModal";
import LitigationResetModal from "../CaseModals/LitigationResetModal";
import StageModal from "../CaseModals/StageModal";
import PowerOfAttorneyModal from "../CaseModals/PowerOfAttorneyModal";
import ResendEmailModal from "../CaseModals/ResendEmailModal";
import PaymentTypeSwitchModal from "../CaseModals/PaymentTypeSwitchModal";
import CourtAppointmentModal from "../CaseModals/CourtAppointmentModal";
import CreateActivityNoteModal from "../CaseModals/CreateActivityNoteModal";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";
import RequestDataCopyModal from "../CaseModals/RequestDataCopyModal";
import RequestPersonalAffectionModal from "../CaseModals/requestPersonalAffectionModal";
import CallModal from "../CaseModals/CallModal";
import { useCall } from "../../../provider/CallProvider";
import StatusCheckModal from "../CaseModals/StatusCheckModal";
import { ProductUnion } from "../../../types/ProductUnion";
import CreateAdministrativeLawCaseModal from "../CaseModals/CreateAdministrativeLawCaseModal";
import ReassignCaseModal from "../CaseModals/ReassignCaseModal";
import ProductChangeModal from "../CaseModals/ProductChangeModal";
import CaseRelatedDrawerPortals from "./CaseRelatedDrawerPortals";

type CaseRelatedOverlaysProps = {
  open: string;
  setOpen: Function;
  refreshActivities: Function;
  refreshPage: Function;
  product: ProductUnion;
};

const CaseRelatedOverlays = ({ open, setOpen, refreshActivities, refreshPage, product }: CaseRelatedOverlaysProps) => {
  const currentUser = useCurrentUser();

  const { callModalOpen, closeCallModal } = useCall();

  const handleClose = () => {
    setOpen("");
  };

  return (
    <>
      <CaseRelatedDrawerPortals refreshActivities={refreshActivities} />
      <UploadFile open={open === "upload"} product={product} closeDialog={handleClose} />
      <CallModal open={open === "" && callModalOpen} handleClose={closeCallModal} product={product} />
      {!currentUser.isExternal && (
        <>
          <CreateActivityNoteModal
            open={open === "callNotes"}
            product={product}
            closeDialog={handleClose}
            updateActivities={() => refreshActivities()}
          />
          <CreatePaidTaskModal
            open={open === "paidTask"}
            product={product}
            handleClose={handleClose}
            refreshPage={refreshPage}
          />
          <PauseModal open={open === "pause"} product={product} handleClose={handleClose} refreshPage={refreshPage} />
          {product.productCategory === "administrativeLaw" && (
            <CreateAdministrativeLawCaseModal
              open={open === "createAdministrativeLawCase"}
              product={product}
              handleClose={handleClose}
              refreshPage={refreshPage}
            />
          )}
          <StatusModal open={open === "status"} product={product} handleClose={handleClose} refreshPage={refreshPage} />
          <DeleteCaseOrAccountModal
            open={open === "delete"}
            product={product}
            handleClose={handleClose}
            refreshPage={refreshPage}
          />
          <LitigationResetModal
            open={open === "resetLitigation"}
            product={product}
            handleClose={handleClose}
            refreshPage={refreshPage}
          />
          <StageModal open={open === "stage"} product={product} handleClose={handleClose} refreshPage={refreshPage} />
          <PowerOfAttorneyModal
            open={open === "powerOfAttorney"}
            product={product}
            handleClose={handleClose}
            refreshPage={refreshPage}
          />
          <ResendEmailModal open={open === "resendEmail"} product={product} handleClose={handleClose} />
          <PaymentTypeSwitchModal
            open={open === "privatePayer"}
            product={product}
            handleClose={handleClose}
            refreshPage={refreshPage}
          />
          <CourtAppointmentModal
            open={open === "courtAppointment"}
            product={product}
            handleClose={handleClose}
            refreshPage={refreshPage}
          />
          <RequestDataCopyModal open={open === "requestDataCopy"} product={product} handleClose={handleClose} />
          <RequestPersonalAffectionModal
            product={product}
            handleClose={handleClose}
            open={open === "requestPersonalAffection"}
          />
          <StatusCheckModal product={product} open={open === "statusCheck"} handleClose={handleClose} />
          <ReassignCaseModal
            product={product}
            open={open === "reassignCase"}
            handleClose={handleClose}
            refreshPage={refreshPage}
          />
          {product.productClassName === "pendingCase" && (
            <ProductChangeModal product={product} open={open === "productChange"} handleClose={handleClose} />
          )}
        </>
      )}
    </>
  );
};
export default CaseRelatedOverlays;
